import { render, staticRenderFns } from "./skeletonStudy.vue?vue&type=template&id=4574ed39&scoped=true"
var script = {}
import style0 from "./skeletonStudy.vue?vue&type=style&index=0&id=4574ed39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574ed39",
  null
  
)

export default component.exports